/*
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-09-30 14:48:29
 * @LastEditors: linwc
 * @LastEditTime: 2026-07-31 15:43:42
 */
import { loadLanguageAsync } from '@/lang/index';
const language = process.env.VUE_APP_CLOUD_DEFAULT_LANGUAGE;

export default {
  namespaced: false, //开启命名空间，更好的区分使用stage,防止不同stage模块中的方法重名
  state: {
    language
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
      // localStorage.setItem('language', curlanguage);
    }
  },

  actions: {
    setLang({ commit }, lang) {
      return new Promise((resolve, reject) => {
        commit('setLanguage', lang);
        loadLanguageAsync(lang)
          .then(() => {
            resolve();
          })
          .catch(e => {
            reject(e);
          });
      });
    }
  },

  getters: {
    language: state => state.language,
    isZh: state => {
      if (['zh', 'cn'].includes(state.language) && process.env.VUE_APP_CLOUD_DEFAULT_LANGUAGE === 'zh') {
        return true;
      }

      return false;
    },
    isCnEnv: state => {
      if (process.env.VUE_APP_CLOUD_DEFAULT_LANGUAGE === 'zh') {
        return true;
      }
      return false;
    }
  }
};
